import React from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import THUserMaintenance from "./THUserMaintenance";
import ManageAccess from "../ManageAccess";

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div hidden={value !== index}>
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function SideNavbar({ trackId }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Vertical Tabs */}
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        sx={{
          borderRight: 1,
          borderColor: "divider",
          minWidth: 150,
          bgcolor: "#fff",
          color: "white",
          "& .MuiTab-root": {
            fontFamily: "Graphik-Regular",
            textTransform: "capitalize",
            alignItems: "start",
          },
        }}
      >
        <Tab label="Add User" key={0}/>
        <Tab label="Active Users" key={1}/>
        <Tab label="Inactive Users" key={2}/>
      </Tabs>

      {/* Content Section */}
      <Box sx={{ flexGrow: 1 }}>
        <TabPanel value={value} index={0}>
          <ManageAccess trackId={trackId} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <THUserMaintenance trackId={trackId} show="active" />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <THUserMaintenance trackId={trackId} show="inactive" />
        </TabPanel>
      </Box>
    </Box>
  );
}
